import { UserOperation } from '../../../../../core/enums/user-operation';
import { ITimeBlockComponentItem } from './time-block-component-item-types';
import { ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { TimeBlockGeometryData } from '../../../../../core/models/timeblock/time-block-geometry-data.model';
import {
  TimeBlockDayOrWeekFixIntervalType,
  TimeBlockDayOrWeekVariableIntervalType,
  TimeBlockMonthFixIntervalType,
  TimeBlockMonthVariableIntervalType,
} from '../../../../../core/models/timeblock/time-block-view-type.model';

export type TimeBlockDialogItem = {
  operation: UserOperation;
  timeBlockItem: ITimeBlockComponentItem;
};

export type TimeBlockHookContainer = {
  vcr: ViewContainerRef;
  cd: ChangeDetectorRef;
};

export enum TimeBlockType {
  GhostBlock, // Copy of a block used as indicator when dragging / resizing.
  TransformingBlock, // Copy of a time block that can be dragged / resized freely.
  NonExistingBlock, // Created by user click. Can be resized. Not persisted in database yet.
  ExistingBlock, // Persisted in database.
}

export enum TimeBlockContentType {
  Project,
  Absence,
  Appointment,
}

export enum FixInterval {
  FullWorkingDay = 'full_working_day',
  HalfWorkingDay = 'half_working_day',
}

export enum TimeBlockIntervalFilter {
  FixIntervalTimeBlocks, // full day or half day time blocks
  VariableIntervalTimeBlocks, // time blocks with arbitrary start and end times.
  All,
}

export type TimeBlockHttpResponseType = {
  timeblock_project_type: any[];
  timeblock_absence_type: any[];
};

export interface ITimeBlockViewType {
  geometryData: TimeBlockGeometryData | null;
}

export interface IVariableIntervalViewType extends ITimeBlockViewType {
  laneIndex: number;
}

export interface IFixIntervalViewType extends ITimeBlockViewType {
  laneIndexStart: number;
  laneIndexEnd: number;
  parallelIndex: number;
}

export interface IDragTimeBlock {
  beforeStartDragging: () => void;
  drag: (event: Interact.DragEvent | number) => void;
  afterDragging: (event: Interact.DragEvent) => void;
}

export type TimeBlockIndexSelector = {
  id: number;
  partNr: number;
};

export type CompoundTimeBlockViewType =
  | TimeBlockDayOrWeekFixIntervalType
  | TimeBlockDayOrWeekVariableIntervalType
  | TimeBlockMonthFixIntervalType
  | TimeBlockMonthVariableIntervalType;

export type TimeBlockRequestParams = {
  selectedUserIds: number[];
  isBillable: boolean | null;
  isInvoiced: boolean | null;
  timeBlockTypes: TimeBlockContentType[];
  startDate?: Date;
  endDate?: Date;
};

export type TimeBlockGrouped = {
  variableIntervalTimeBlocks: {
    timeBlockProjectType: ITimeBlockComponentItem[];
    timeBlockAbsenceType: ITimeBlockComponentItem[];
  };
  fixIntervalTimeBlocks: {
    timeBlockProjectType: ITimeBlockComponentItem[];
    timeBlockAbsenceType: ITimeBlockComponentItem[];
  };
};
